import React from 'react';

const TodoUnderline = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='49'
			height='48'
			fill='none'
			viewBox='0 0 49 48'
		>
			<path
				fill='#2d2d2d'
				d='M39.5 4.5H35v3h3V36H12.5V7.5h3v-3H11c-.825 0-1.5.675-1.5 1.5v31.5c0 .825.675 1.5 1.5 1.5h28.5c.825 0 1.5-.675 1.5-1.5V6c0-.825-.675-1.5-1.5-1.5z'
			></path>
			<path
				fill='#2d2d2d'
				d='M18.5 10.5H32c.825 0 1.5-.675 1.5-1.5V3c0-.825-.675-1.5-1.5-1.5H18.5c-.825 0-1.5.675-1.5 1.5v6c0 .825.675 1.5 1.5 1.5zm1.5-6h10.5v3H20v-3zM17.436 19.064c.3.285.674.435 1.064.435s.765-.15 1.066-.435l4.5-4.5-2.13-2.13-3.436 3.45-1.934-1.95-2.13 2.13 3 3zM21.934 19.934l-3.435 3.45-1.935-1.935-2.115 2.115 3 3c.285.285.66.435 1.05.435s.765-.15 1.065-.435l4.5-4.5-2.13-2.13zM16.564 28.934L14.45 31.05l3 3c.285.3.66.45 1.05.45s.765-.15 1.065-.435l4.5-4.5-2.115-2.115-3.45 3.435-1.935-1.95zM35 15h-9v3h9v-3zM35 22.5h-9v3h9v-3zM35 30h-9v3h9v-3zM38 45H12.5v3H38v-3z'
			></path>
		</svg>
	);
};

export default TodoUnderline;
